module.exports = __webpack_public_path__ + "img/fig14.ba98bf6b.jpg";